import React, { Component } from 'react';
import cn from 'classnames';
import { Form, Button, Input, Spin, Icon, Drawer, Popover, Tag, Select } from 'antd';
import {
  CheckCircleOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { sagaModal } from 'redux-saga-modal'
import styles from './style.module.less';
import * as services from '@/models/orders/services';
import { showPriceDialog } from '@/models/orders/actions';
import Countdown from '@/components/Countdown';
import StatusBadge from '@/components/StatusBadge';
import CallNumber from '@/components/CallNumber';
import dayjs from 'dayjs';
import { Select as SelectArea } from '@/components/SelectArea'
import { serviceInfo } from "@/utils/skill";
import VeteranStatus from '@/components/VeteranStatus';
import { PAGE_SIZE, getVisibleLists, resolvePaginationMode, resolveServerHasMore, uniqByKey } from './pagination';

const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';
function OrderRow(props) {
  return (
    <div className={cn(styles.row, props.block && styles.block)}>
      <div className={styles.rowTit}>{props.title}</div>
      <div className={styles.rowBody}>{props.children}</div>
    </div>
  );
}
@connect()
@Form.create()
class AssignWorkerForm extends Component {
  state = {
    loading: false,
    selected: null,
    selectedWorker: null,
    list: [],
    workerList: [],
    total: 0,
    page: 1,
    pageSize: PAGE_SIZE,
    hasMore: false,
    loadingMore: false,
    paginationMode: 'client',
    sourceData: {
      quotedList: [],
      assignableList: [],
    },
    filters: {
      keyword: '',
      service_area: '',
      service_info: '',
    },
    showTips: false,
    workerQuoteOrNot: true, // 工人是否报价
    quotationEndTime: 0,
  }

  componentDidMount() {
    this.fetchList()
  }
  fetchList = async (params = {}, options = {}) => {
    const nextPage = options.page || 1;
    const append = Boolean(options.append);
    const nextFilters = {
      ...this.state.filters,
      ...params,
      keyword: params.keyword !== undefined ? params.keyword : this.state.filters.keyword,
      service_area: params.service_area !== undefined ? params.service_area : this.state.filters.service_area,
      service_info: params.service_info !== undefined ? params.service_info : this.state.filters.service_info,
    };
    this.setState({
      loading: !append,
      loadingMore: append,
      filters: nextFilters,
    })
    services.getBaojiaList({
      orderId: this.props.id,
      keyword: nextFilters.keyword || '',
      service_area: nextFilters.service_area || '',
      service_info: nextFilters.service_info || '',
      page: nextPage,
      pageSize: this.state.pageSize,
    }).then(res => {
      const paginationMode = resolvePaginationMode(res, this.state.pageSize);
      const quotedList = res.list || [];
      const assignableList = res.workerList || [];
      if (paginationMode === 'client') {
        const visible = getVisibleLists({
          quotedList,
          assignableList,
        }, nextPage, this.state.pageSize);
        this.setState({
          loading: false,
          loadingMore: false,
          page: nextPage,
          paginationMode,
          sourceData: {
            quotedList,
            assignableList,
          },
          list: visible.list,
          workerList: visible.workerList,
          hasMore: visible.hasMore,
          total: res.total,
          showTips: false,
          workerQuoteOrNot: true,
          selected: this.props?.order?.worker?._id || null,
          selectedWorker: this.props?.order?.worker || null,
          quotationEndTime: res.quotationEndTime
        })
        return;
      }
      const mergedQuotedList = append ? uniqByKey([...this.state.sourceData.quotedList, ...quotedList]) : quotedList;
      const mergedAssignableList = append ? uniqByKey([...this.state.sourceData.assignableList, ...assignableList]) : assignableList;
      const currentCount = mergedQuotedList.length + mergedAssignableList.length;
      this.setState({
        loading: false,
        loadingMore: false,
        page: nextPage,
        paginationMode,
        sourceData: {
          quotedList: mergedQuotedList,
          assignableList: mergedAssignableList,
        },
        list: mergedQuotedList,
        workerList: mergedAssignableList,
        hasMore: resolveServerHasMore(res, nextPage, this.state.pageSize, currentCount),
        total: res.total,
        showTips: false,
        workerQuoteOrNot: true,
        selected: this.props?.order?.worker?._id || null,
        selectedWorker: this.props?.order?.worker || null,
        quotationEndTime: res.quotationEndTime
      })
    }).catch(() => {
      this.setState({
        loading: false,
        loadingMore: false,
      })
    })
  }
  handleLoadMore = () => {
    if (this.state.loading || this.state.loadingMore || !this.state.hasMore) {
      return;
    }
    const nextPage = this.state.page + 1;
    if (this.state.paginationMode === 'client') {
      const visible = getVisibleLists(this.state.sourceData, nextPage, this.state.pageSize);
      this.setState({
        page: nextPage,
        list: visible.list,
        workerList: visible.workerList,
        hasMore: visible.hasMore,
      });
      return;
    }
    this.fetchList({}, { page: nextPage, append: true });
  }
  handleScroll = e => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop - clientHeight < 120) {
      this.handleLoadMore();
    }
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.fetchList(values, { page: 1, append: false })
    });
  };
  // workerQuoteOrNot 工人是否报价
  handleSelect = (id, worker, workerQuoteOrNot = false) => () => {
    // if (this.props?.order?.worker) {
    //   message.error('一口价工单已被师傅抢单');
    //   return false
    // }
    // if (!workerQuoteOrNot) {
    //   if (!this.props?.order?.worker_fee?.length) {
    //     this.setState({
    //       showTips: true
    //     })
    //     setTimeout(() => {
    //       this.setState({
    //         showTips: false
    //       })
    //     }, 2000);
    //     return false
    //   }

    // }
    this.setState({
      showTips: false,
      workerQuoteOrNot: workerQuoteOrNot,
      // workerQuoteOrNot: this.state.selected === id ? false : workerQuoteOrNot,
      selectedWorker: worker,
      selected: this.state.selected === id ? null : id
    })
  }

  handleSave = () => {
    // if (!this.state.workerQuoteOrNot) {
    //   return false
    // }
    if (this.state.selected) {
      this.props.submit({
        selected: this.state.selected,
        worker: this.state.selectedWorker,
        workerQuoteOrNot: this.state.workerQuoteOrNot,
      })
    }
  }
  normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }
    if (value && value._id) {
      return value._id
    }
    return null
  }
  onSuccess = () => {

  }

  handleChangeFixedPrice = () => {
    this.props?.dispatch(
      showPriceDialog({
        ele: document.getElementById('assignWorkerDrawer')?.querySelector('.ant-drawer-content'),
        title: '一口价工单',
        order: this.props?.orderMap,
        field: 'fee',
        type: 'fixed_price',
        // clickTarget: 'enterprise',
        onSuccess: this.onSuccess
      })
    );
  }

  render() {
    const { showBuyoutPrice = true } = this.props
    const { getFieldDecorator } = this.props.form;
    const { loading, list, workerList, total, selected, hasMore, loadingMore } = this.state
    const formItemLayout = {
      labelCol: { span: 0 },
      wrapperCol: { span: 24 },
    };
    //计算师傅的订单总金额
    const calWorkerFee = (worker_fee, service_fee = 0) => {
      let total = 0;
      if (worker_fee) {
        total = worker_fee.reduce((t, d) => (t += (Number(d.price) || 0)), 0)
      }
      // if (isTenantMode) {
      total += service_fee
      // }
      return total ? total.toFixed(2) : total
    };
    const distanceToKilometers = (num = 0) => {
      let val = num / 1000
      if (val) {
        num = val.toFixed(1) + '公里'
      }
      return num
    }

    return (
      <div style={{ paddingBottom: 120 }}>
        {(isManagerMode || (isTenantMode && this.props.order.ticket_type != 2)) &&
          <Form layout="inline" {...formItemLayout} onSubmit={this.handleSubmit}>
            <Form.Item >
              {getFieldDecorator('service_area', {
                normalize: this.normalizeTenant
              })(
                <SelectArea style={{ width: 160, marginTop: 4 }} placeholder="请选择服务范围" />
              )}
            </Form.Item>

            <Form.Item >
              {getFieldDecorator('keyword', {
              })(
                <Input placeholder="请输入姓名、备注" />
              )}
            </Form.Item>
            <Form.Item >
              {getFieldDecorator('service_info', {
              })(
                <Select allowClear={true} placeholder="请选择服务承诺" style={{ width: 160 }}>
                  {serviceInfo[0].items.map(item => <Select.Option title={item} value={item} key={item}>{item}</Select.Option>)}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" >
                搜索
              </Button>
            </Form.Item>
            {this.props?.order?.worker && showBuyoutPrice && <Form.Item>
              <Button type="primary" onClick={() => { this.handleChangeFixedPrice() }}>
                发布一口价工单
              </Button>
            </Form.Item>}
          </Form>
        }

        <Spin spinning={loading}>
          <div className={styles.listScroll} onScroll={this.handleScroll}>
            <div className={styles.userWrap}>
              <div className={styles.tipswrap}>
                <div className={styles.countdown}>
                  {!!this.state.quotationEndTime && <>
                    <div className={styles.tips}>报价剩余时间：</div>
                    <Countdown time={dayjs(this.state.quotationEndTime || 0).valueOf() - dayjs().valueOf()} style={{ fontSize: '16px' }} />
                  </>}
                </div>
                <div>
                  已报价师傅 <span className={styles.num}>{list.length}</span> 位 {isManagerMode && <>/ 可指派师傅 <span className={styles.num}>{total}</span> 位</>}
                </div>
              </div>
              <div className={styles.userList}>
                {
                  !list.length && !workerList.length && (
                    <div className={styles.empty}>没有匹配的数据</div>
                  )
                }
                {
                  list.map(item => (
                  <div className={styles.userbox}
                    key={item._id}
                  >
                    <div className={styles.lf}>
                      <div className={styles.lf_avater}>
                        <img src={item?.worker?.user?.avatar} />
                        <div className={cn(styles.workstatus, item?.worker?.user?.isActive ? styles.active : '')}></div>
                      </div>
                      <div className={styles.lf_name}>
                        <div className={styles.userin}>
                          <div className={styles.username}>{item?.worker?.realname}&nbsp;{isManagerMode && <span>{item?.worker?.memo?.length > 0 ? item?.worker?.memo[0] : ''}</span>} </div>
                          <div>
                            <Popover
                              trigger="click"
                              placement="bottomRight"
                              content={(
                                <div style={{ width: 350, minHeight: 200, maxHeight: 500, overflowX: 'hidden' }}>
                                  {item?.worker?.service_info?.map((val1, inx1) => {
                                    return (
                                      <div key={inx1} style={{ marginBottom: 5 }}>
                                        <div style={{ color: '#333', marginBottom: 10 }}>{val1.category}：</div>
                                        <div>
                                          {val1.items.map((val2, inx2) => <Tag key={inx2} style={{ marginBottom: 5 }}>{val2}</Tag>)}
                                        </div>
                                      </div>
                                    )
                                  })}
                                  {item?.worker?.skill_list.map((val1, inx1) => {
                                    return (
                                      <div key={inx1} style={{ marginBottom: 5 }}>
                                        <div style={{ color: '#333', marginBottom: 10 }}>{val1.category}：</div>
                                        <div>
                                          {val1.items.map((val2, inx2) => <Tag key={inx2} style={{ marginBottom: 5 }}>{val2}</Tag>)}
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            >
                              <Button size="small" type="link" style={{ marginRight: 10 }}>师傅技能和服务承诺</Button>
                            </Popover>

                            <Button
                              size="small"
                              type="primary"
                              ghost={item._id !== selected}
                              style={{ width: '72px' }}
                              onClick={this.handleSelect(item.worker._id, item?.worker, true)}
                            >
                              {item.worker._id === selected ? <Icon type="check" style={{ fontSize: '18px' }} /> : '指派他'}
                            </Button>
                          </div>
                        </div>
                        <div className={styles.tags}>
                          <VeteranStatus isVeteran={item?.worker?.isVeteran} />
                          {item?.worker?.isMargin == 1 ?
                            <img src="/images/icon-defend-active.png" style={{ width: 24, height: 24, marginRight: 10 }} /> :
                            <img src="/images/icon-defend.png" style={{ width: 24, height: 24, marginRight: 10 }} />
                          }
                          {(isManagerMode || (isTenantMode && this.props.order.ticket_type != 2)) && <CallNumber show number={item?.worker?.user?.mobile} size="small" />}
                        </div>
                        {isManagerMode && <div className={styles.tips} style={{ marginBottom: 0 }}>
                          <span>接单率：{item?.wper || 0}%</span>
                          <span>完单率：{item?.oper || 0}%</span>
                          <span>预约及时率：{item?.yper || 0}%</span>
                          <span>准时率：{item?.zper || 0}%</span>
                          <span>好评率：{item?.worker?.praise || 0}%</span>
                        </div>}
                        <div className={styles.tips}>
                          <span>服务次数：{item?.worker?.order_quantity || 0}</span>
                          <span>距离客户：{distanceToKilometers(item?.distance) || 0}</span>
                        </div>
                        {(item?.worker?.restStart && item?.worker?.restEnd) && <div className={styles.tips}>

                          {new Date().getTime() < dayjs(item?.worker?.restEnd).valueOf() && <>
                            <Icon type="coffee" style={{ color: "#FF6600" }} />
                            师傅休息时间：{dayjs(item?.worker?.restStart).format("YYYY-MM-DD HH:mm")} 至 {dayjs(item?.worker?.restEnd).format("YYYY-MM-DD HH:mm")}
                          </>}

                        </div>}
                        {/* <Tooltip placement="bottom" title={<span>服务范围：{getServiceList(item.service_area)}<br />能力范围：{getSkillList(item.skill_list)}</span>}>
                          <div className={styles.lf_name_area}>
                            服务范围：{getServiceList(item.service_area)}
                          </div>
                        </Tooltip> */}
                        <div className={styles.userinfo}>
                          <OrderRow title="报价合计：">
                            <span className={styles.textcolor1}>{calWorkerFee([], item?.worker_bj_total)}元</span>
                            {item?.order?.order_flag == 1 && <StatusBadge style={{ color: '#FF731B', background: 'rgba(255, 102, 0, 0.1)', marginLeft: 10 }}>
                              一口价报价
                            </StatusBadge>}
                            <span style={{ marginLeft: 10 }}>平台服务费{item?.service_fee ? item?.service_fee.toFixed(2) : 0}元</span>
                          </OrderRow>
                          <OrderRow title="报价明细：">
                            {item?.worker_fee &&
                              item?.worker_fee.map((item, index) => {
                                return (
                                  <span key={index}>{item.name}{item.price || 0}元&nbsp;</span>
                                );
                              })}

                          </OrderRow>
                          <OrderRow title="师傅留言：">{item?.message || ''}</OrderRow>
                        </div>
                      </div>
                    </div>

                  </div>
                  ))
                }

                {
                  workerList.map(item => (
                  <div className={styles.userbox}
                    key={item._id}
                  >
                    <div className={styles.lf}>
                      <div className={styles.lf_avater}>
                        <img src={item?.worker?.user?.avatar} />
                        <div className={cn(styles.workstatus, item?.worker?.user?.isActive ? styles.active : '')}></div>
                      </div>
                      <div className={styles.lf_name}>
                        <div className={styles.userin}>
                          <div className={styles.username}>{item?.worker?.realname}&nbsp;{isManagerMode && <span>{item?.worker?.memo?.length > 0 ? item?.worker?.memo[0] : ''}</span>} </div>
                          <div>
                            <Popover
                              trigger="click"
                              placement="bottomRight"
                              content={(
                                <div style={{ width: 350, minHeight: 200, maxHeight: 500, overflowX: 'hidden' }}>
                                  {item?.worker?.service_info?.map((val1, inx1) => {
                                    return (
                                      <div key={inx1} style={{ marginBottom: 5 }}>
                                        <div style={{ color: '#333', marginBottom: 10 }}>{val1.category}：</div>
                                        <div>
                                          {val1.items.map((val2, inx2) => <Tag key={inx2} style={{ marginBottom: 5 }}>{val2}</Tag>)}
                                        </div>
                                      </div>
                                    )
                                  })}
                                  {item?.worker?.skill_list?.map((val1, inx1) => {
                                    return (
                                      <div key={inx1} style={{ marginBottom: 5 }}>
                                        <div style={{ color: '#333', marginBottom: 10 }}>{val1.category}：</div>
                                        <div>
                                          {val1.items.map((val2, inx2) => <Tag key={inx2} style={{ marginBottom: 5 }}>{val2}</Tag>)}
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            >
                              <Button size="small" type="link" style={{ marginRight: 10 }}>师傅技能和服务承诺</Button>
                            </Popover>

                            <Button
                              size="small"
                              type="primary"
                              ghost={item?.worker._id !== selected}
                              style={{ width: '72px' }}
                              onClick={this.handleSelect(item?.worker._id, item?.worker)}
                            >
                              {item?.worker._id === selected ? <Icon type="check" style={{ fontSize: '18px' }} /> : '指派他'}
                            </Button>
                          </div>
                        </div>
                        <div className={styles.tags}>
                          <VeteranStatus isVeteran={item?.worker?.isVeteran} />
                          {item?.worker?.isMargin == 1 ?
                            <img src="/images/icon-defend-active.png" style={{ width: 24, height: 24, marginRight: 10 }} /> :
                            <img src="/images/icon-defend.png" style={{ width: 24, height: 24, marginRight: 10 }} />
                          }
                          {(isManagerMode || (isTenantMode && this.props.order.ticket_type != 2)) && <CallNumber show number={item?.worker?.user?.mobile} size="small" />}
                        </div>
                        {isManagerMode && <div className={styles.tips} style={{ marginBottom: 0 }}>
                          <span>接单率：{item?.worker?.wper || 0}%</span>
                          <span>完单率：{item?.worker?.oper || 0}%</span>
                          <span>预约及时率：{item?.worker?.yper || 0}%</span>
                          <span>准时率：{item?.worker?.zper || 0}%</span>
                          <span>好评率：{item?.worker?.praise || 0}%</span>
                        </div>}
                        <div className={styles.tips}>
                          <span>服务次数：{item?.worker?.order_quantity || 0}</span>
                          <span>距离客户：{distanceToKilometers(item?.worker?.distance) || '--'}</span>
                        </div>
                        {(item?.worker?.restStart && item?.worker?.restEnd) && <div className={styles.tips}>
                          <Icon type="coffee" style={{ color: "#FF6600" }} /> 师傅休息时间：{dayjs(item?.worker?.restStart).format("YYYY-MM-DD HH:mm")} 至 {dayjs(item?.worker?.restEnd).format("YYYY-MM-DD HH:mm")}
                        </div>}
                        {/* <Tooltip placement="bottom" title={<span>服务范围：{getServiceList(item.service_area)}<br />能力范围：{getSkillList(item.skill_list)}</span>}>
                          <div className={styles.lf_name_area}>
                            服务范围：{getServiceList(item.service_area)}
                          </div>
                        </Tooltip> */}
                      </div>
                    </div>

                  </div>
                  ))
                }
              </div>
            </div>
            <div className={styles.loadMore}>
              {loadingMore && <span>加载中...</span>}
              {!loadingMore && hasMore && (
                <Button size="small" onClick={this.handleLoadMore}>加载更多</Button>
              )}
              {!hasMore && (list.length > 0 || workerList.length > 0) && (
                <span>已加载全部</span>
              )}
            </div>
          </div>
        </Spin>
        <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            zIndex: 10,
            background: '#fff',
          }}
        >
          {this.state.showTips && <div className={styles.bottomtips}>
            <Icon type="info-circle" />
            指派未报价师傅需要先设置师傅费用-改价
            {/* 指派师傅前需要先设置企业费用-工单总费(企业支付) */}
          </div>}
          {isManagerMode && this.props.order?.is_retail && (
            <div className={styles.bottomtips} style={{ color: '#ff4d4f' }}>
              <Icon type="exclamation-circle" />
              保外工单，客服不能指派师傅
            </div>
          )}
          <div style={{
            borderTop: '1px solid #e9e9e9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 20px',
            height: '64px',
            background: '#fff',
            boxShadow: '0px -2px 4px 0px rgba(0, 0, 0, 0.1)',
          }}>
            <Button type="primary" block shape="round" onClick={this.handleSave}
              disabled={loading || !selected || (isManagerMode && this.props.order?.is_retail)}>
              确定指派
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function AssignWorkerDialog({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Drawer
      className={styles.drawerbox}
      title={ownProps.title}
      destroyOnClose
      width={620}
      visible={isOpen}
      onClose={hide}
      zIndex={996}
      bodyStyle={{ paddingLeft: 10, paddingRight: 10 }}
      id="assignWorkerDrawer"
    >
      <AssignWorkerForm submit={submit} {...ownProps} />
    </Drawer>
  )
}

export default sagaModal({
  name: 'ASSIGN_WORKER_DIALOG',
})(AssignWorkerDialog)
